<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="ORIM-Chapter-Title-Page-Break">PROLOGUE: November 1963</p>
<p class="ORIM-Chapter-Opener-Paragraph">Dr. Martin Abrams carefully packed his handmade pipe, lit the tobacco, and glanced into the file on the right side of his desk. “How do you feel?” he asked, constricting his heavy brown eyebrows.</p>
<p class="ORIM-Body-Text">“Feel?” the patient responded blankly, deep in the well of a trance.</p>
<p class="ORIM-Body-Text">Abrams noted the patient’s discomfort. “You’re relaxed, aren’t you?”</p>
<p class="ORIM-Body-Text">“Yes,” the patient replied unsurely. “Very relaxed.” </p>
<p class="ORIM-Body-Text">“That’s good.”</p>
<p class="ORIM-Body-Text">Silence.</p>
<p class="ORIM-Body-Text">Then: “I want to talk about your mother,” Abrams said.</p>
<p class="ORIM-Body-Text">The patient started to squirm. “I don’t remember my mother.”</p>
<p class="ORIM-Body-Text">“Yes, you do. You remember everything. Tell me about her.” </p>
<p class="ORIM-Body-Text">Hesitating, the patient described the woman and their relationship.</p>
<p class="ORIM-Body-Text">Abrams nodded. “Okay,” he said, jotting notes. “Now tell me how she died.”</p>
<p class="ORIM-Body-Text">The patient exploded in terror. “I don’t remember.”</p>
<p class="ORIM-Body-Text">“You do. Tell me!”</p>
<p class="ORIM-Body-Text">“She died. A long time ago.”</p>
<p class="ORIM-Body-Text">“How?”</p>
<p class="ORIM-Body-Text">“Cancer.”</p>
<p class="ORIM-Body-Text">“That’s not the truth. Tell me how she died!”</p>
<p class="ORIM-Body-Text">“Cancer. Melanoma. I went to see her in the hospital. She was in tremendous pain.”</p>
<p class="ORIM-Body-Text">“Is that all?”</p>
<p class="ORIM-Body-Text">The patient rambled on, then stopped, sweating.</p>
<p class="ORIM-Body-Text">Abrams relit his pipe and clenched his teeth tightly on the stem. “How did she die?” he demanded once more.</p>
<p class="ORIM-Body-Text">The patient looked wildly around the room.</p>
<p class="ORIM-Body-Text"><em class="italic">“How?”</em></p>
<p class="ORIM-Body-Text">“They brought her back from the hospital. One morning her nurse was sick and couldn’t come in, and Mother was in more pain than ever. She said that if I loved her, I would help her to die. I cried. Then I turned off her support machines and went to school. When I got home, she was dead.”</p>
<p class="ORIM-Body-Text">“How did you feel about this?”</p>
<p class="ORIM-Body-Text">“Guilty.”</p>
<p class="ORIM-Body-Text">“And what did you do about your guilt?”</p>
<p class="ORIM-Body-Text">“I don’t remember.”</p>
<p class="ORIM-Body-Text">“You do! Tell me!”</p>
<p class="ORIM-Body-Text">Agony. Confusion. Then: “I couldn’t live with it.”</p>
<p class="ORIM-Body-Text">“So…”</p>
<p class="ORIM-Body-Text">“I tried to kill myself.”</p>
<p class="ORIM-Body-Text">Satisfied, Abrams probed deeper, quickly compiling a dozen pages of impressions. Then, concluding the session, he broke the trance. Within seconds, the patient was lucid.</p>
<p class="ORIM-Body-Text">Abrams gave the patient some coffee. “I want to ask you some questions,” he said.</p>
<p class="ORIM-Body-Text">The patient nodded.</p>
<p class="ORIM-Body-Text">“How did your mother die?”</p>
<p class="ORIM-Body-Text">“Cancer.”</p>
<p class="ORIM-Body-Text">“Wasn’t she murdered?”</p>
<p class="ORIM-Body-Text">“Murdered? Are you crazy?”</p>
<p class="ORIM-Body-Text">“Me? No. And neither are you.”</p>
<p class="ORIM-Body-Text">The patient laughed. </p>
<p class="ORIM-Body-Text">The psychiatrist shook his head. “I want to ask you something else.”</p>
<p class="ORIM-Body-Text">“Okay.”</p>
<p class="ORIM-Body-Text">“Did you ever try to kill yourself?”</p>
<p class="ORIM-Body-Text">“No. Absolutely not.”</p>
<p class="ORIM-Body-Text">“Are you sure?”</p>
<p class="ORIM-Body-Text">“Yes.”</p>
<p class="ORIM-Body-Text">“All right. That’s good.”</p>
<p class="ORIM-Body-Text">The patient smiled and heaved a sigh of relief.</p>
<p class="ORIM-Body-Text">Abrams sat back in the chair and dumped the burned tobacco from his pipe into the wastepaper basket. He closed his notebook and nodded, all the while marveling at the most extraordinary case of repression he’d ever seen. </p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Untitled-1-2.vue?19155e7a